import React from 'react';
import { useApp } from '../../context/Store';
import SafeIcon from '../../common/SafeIcon';
import { FiSearch, FiBell, FiCpu, FiChevronRight, FiChevronDown } from 'react-icons/fi';
import Button from '../ui/Button';

export default function Topbar() {
  const { currentWorkspace, currentMission, toggleAIPanel } = useApp();

  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-6 shrink-0">
      <div className="flex items-center text-sm text-slate-600 font-medium">
        <span className="flex items-center gap-1 hover:text-slate-900 cursor-pointer">
          {currentWorkspace} <SafeIcon icon={FiChevronDown} className="text-slate-400" />
        </span>
        <SafeIcon icon={FiChevronRight} className="mx-2 text-slate-400" />
        <span className="text-slate-900 font-semibold">{currentMission}</span>
      </div>

      <div className="flex items-center gap-4">
        <div className="relative">
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input 
            type="text" 
            placeholder="Search organizational intelligence..." 
            className="pl-9 pr-4 py-1.5 bg-slate-50 border border-slate-200 rounded-md text-sm w-64 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all"
          />
        </div>

        <Button variant="ghost" size="sm" className="px-2">
          <SafeIcon icon={FiBell} className="text-lg" />
        </Button>

        <Button variant="ai" size="sm" onClick={toggleAIPanel} className="gap-2">
          <SafeIcon icon={FiCpu} />
          Ask OS
        </Button>

        <div className="w-8 h-8 rounded-full bg-slate-800 text-white flex items-center justify-center text-sm font-medium ml-2">
          JD
        </div>
      </div>
    </header>
  );
}